<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="mini"
      resizable
      auto-resize
      show-footer-overflow
      :columns="tableColumns"
      :loading="loading"
      :data="tableData"
      :max-height="300"
    >
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
}
</script>
